import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbb447ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bus-stop-change-wrapper"
}
const _hoisted_2 = { class: "bus-stop-change-text" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.willBeChanged)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "bus-stop-change-info",
            onClick: _withModifiers($setup.onClickHelpIcon, ["stop"])
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString($setup.busStopChangeText), 1 /* TEXT */),
            _createVNode($setup["InlineSvg"], {
              class: "help-icon",
              src: require('@/assets/icons/fi-help-circle.svg'),
              "aria-label": "자세히보기"
            }, null, 8 /* PROPS */, ["src"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
      ($setup.shouldShowBusStopDeleteGuide)
        ? (_openBlock(), _createBlock($setup["InfoModal"], {
            key: 0,
            title: "정류장 폐지 안내",
            confirmButtonTitle: "닫기",
            onOnClickConfirmButton: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowBusStopDeleteGuide(false)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: $setup.deleteGguideContentHtml,
                style: {"line-height":"1.4"}
              }, null, 8 /* PROPS */, _hoisted_3)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
      ($setup.shouldShowBusStopAddGuide)
        ? (_openBlock(), _createBlock($setup["InfoModal"], {
            key: 0,
            title: "정류장 추가 안내",
            confirmButtonTitle: "닫기",
            onOnClickConfirmButton: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowBusStopAddGuide(false)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: $setup.addGguideContentHtml,
                style: {"line-height":"1.4"}
              }, null, 8 /* PROPS */, _hoisted_4)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}